<b-modal v-model="modal_special_requirement_ES8" size="lg" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <template v-if="phase !== 'select' && phase !== 'history_list' && phase !== 'read' && phase !== 'preview_select'
          && phase !== 'preview_info' && phase !== 'preview_display'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="text-left align-middle">
                <div class="box-margin-right work-support-message" style="white-space: break-spaces;">
                  {{ workSupportMessage }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="phase === 'start'">
          <div class="text-left align-middle mt-5">
            <div class="work-support-message">{{ $t(`${i18nWsKey}.label_start_confirm`) }}</div>
          </div>
          <div class="mt-3">
            <b-form-checkbox v-model="confirmChecked">
              <div class="work-support-message">{{ $t(`individual.label_confirm_yes`) }}</div>
            </b-form-checkbox>
          </div>
          <div class="text-left align-middle mt-3">
            <div class="work-support-message">{{ $t(`${i18nWsKey}.label_start_agreement`) }}</div>
          </div>
          <div class="mt-3">
            <b-form-checkbox v-model="agreementChecked">
              <div class="work-support-message">{{ $t(`individual.label_confirm_yes`) }}</div>
            </b-form-checkbox>
          </div>
        </template>
        <template v-if="phase === 'select'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="text-left align-middle">
                <b-form-select class="form-control" v-model="selectedMode" :options="modeList"
                  :select-size="6"></b-form-select>
              </div>
            </div>
          </div>
        </template>
        <template v-if="phase === 'history_list'">
              <div class="text-left align-middle support-table support-table-scroll">
            <!-- 共通コンポーネントを使用すると、チェックボックスに変更を加えた際に、再描画されてソートが解除されてしまう -->
            <!-- useSortFixは非推奨のため、独自で定義する -->
            <table class="table table-sm overflow-auto table-dr-style mt-2">
              <tr v-if="historyListColumns">
                <th v-for="(column, i) in historyListColumns" :key="i">
                  <div v-if="column.useSort" class="table-header-cursor" @click="historyListSort(column)">
                    <span>{{ $t(column.label) }}</span>
                    <span v-if="historyListCurrentSort === column.name" v-html="geHistoryListSortIcon()"></span>
                  </div>
                  <div v-else>
                    <span>{{ $t(column.label) }}</span>
                  </div>
                </th>
              </tr>
              <tr v-for="(data, index) in sortedDisplayList" :key="index" @click="historyListRowClickedEvent(data)">
                <td v-for="(column, i) in historyListColumns" :key="i" :class="getTdStyle(index)"
                  class="cursor-default">
                  <div v-if="column.name === 'selected'">
                    <input type="checkbox" v-model="data.selected" />
                  </div>
                  <span v-else>{{ data[column.name] }}</span>
                </td>
              </tr>
            </table>
          </div>
        </template>
        <template v-if="phase === 'read'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="text-left align-middle">
                <custom-Progress :value="progress" :max="progressMax"
                  :message="$t(`${i18nWsKey}.label_phase_message`) + `(${processedDidCount}/${totalDidCount})`" />
              </div>
            </div>
          </div>
        </template>
        <template v-if="phase === 'partial_failed'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="text-left align-middle work-support-message">
                <ul>
                  <template v-for="item in selectedHistoryListItems">
                    <template v-for="history in item.histories">
                      <li v-if="history.is_preprocess_failed">
                        {{ $t(`${i18nWsKey}.${item.image_type}`) }} {{ $t(`${i18nWsKey}.${history.image_order}`) }}
                      </li>
                    </template>
                  </template>
                </ul>
              </div>
            </div>
          </div>
        </template>
        <template v-if="phase === 'input_password'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="text-left align-middle">
                <b-form-input type="password" v-model="inputData" autocomplete="off" size="sm"
                  :state="isAlert.data.valid" />
                <b-form-invalid-feedback>{{ $t(isAlert.data.msg) }}</b-form-invalid-feedback>
              </div>
            </div>
          </div>
        </template>
        <template v-if="phase === 'preview_select'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="text-left align-middle support-table support-table-scroll">
                <!-- 共通コンポーネントを使用すると、ハイライト設定時に再描画されてソートが解除されてしまう -->
                <!-- useSortFixは非推奨のため、独自で定義する -->
                <table class="table table-sm overflow-auto table-dr-style mt-2">
                  <tr v-if="previewSelectColumns">
                    <th v-for="(column, i) in previewSelectColumns" :key="i">
                      <div v-if="column.useSort" class="table-header-cursor" @click="previewSelectSort(column)">
                        <span>{{ $t(column.label) }}</span>
                        <span v-if="previewSelectCurrentSort === column.name"
                          v-html="getPreviewSelectSortIcon()"></span>
                      </div>
                      <div v-else>
                        <span>{{ $t(column.label) }}</span>
                      </div>
                    </th>
                  </tr>
                  <tr v-for="(data, index) in sortedPreviewList" :key="index"
                    :class="{ 'table-row-stripe': index % 2 === 0 }" @click="previewSelectRowClickedEvent(data)">
                    <td v-for="(column, i) in previewSelectColumns" :key="i"
                      :class="{ 'field-highlight': data.fieldSpec && data.fieldSpec[column.name] === 'highlight', 'field-bold': data.fieldSpec && data.fieldSpec[column.name] === 'highlight' }">
                      <span>{{ data[column.name] }}</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </template>
        <template v-if="phase === 'preview_info'">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="text-left align-middle support-table support-table-scroll">
                <div class="box-margin-right work-support-message" style="white-space: break-spaces;">
                  {{ $t(`${i18nWsKey}.label_history_name`) + `: ${selectedPreviewItem.displayName}` }}
                </div>
                <!-- 共通コンポーネントを使用すると、ハイライト設定時に再描画されてソートが解除されてしまう -->
                <!-- useSortFixは非推奨のため、独自で定義する -->
                <table class="table table-sm overflow-auto table-dr-style mt-3">
                  <tr v-if="previewInfoColumns">
                    <th v-for="(column, i) in previewInfoColumns" :key="i">
                      <div v-if="column.useSort" class="table-header-cursor" @click="previewInfoSort(column)">
                        <span>{{ $t(column.label) }}</span>
                        <span v-if="previewInfoCurrentSort === column.name" v-html="getPreviewInfoSortIcon()"></span>
                      </div>
                      <div v-else>
                        <span>{{ $t(column.label) }}</span>
                      </div>
                    </th>
                  </tr>
                  <tr v-for="(data, index) in sortedPreviewInfoItems" :key="index"
                    :class="{ 'table-row-stripe': index % 2 === 0 }" @click="previewInfoRowClickedEvent(data)">
                    <td v-for="(column, i) in previewInfoColumns" :key="i"
                      :class="{ 'field-highlight': data.fieldSpec && data.fieldSpec[column.name] === 'highlight', 'field-bold': data.fieldSpec && data.fieldSpec[column.name] === 'highlight' }">
                      <span>{{ data[column.name] }}</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </template>
        <template v-if="phase === 'preview_display'">
          <div v-if="imageData.third_image">
            <div class="ws-section">
              <div class="ws-line">
                <div class="ws-col-label">
                  <span class="ws-label">{{ $t(`${i18nWsKey}.label_when_operation`) }}</span>
                </div>
                <div class="ws-col-media">
                  <canvas ref="first_image" class="img-fluid" :width="width" :height="height"></canvas>
                </div>
              </div>
              <div class="ws-line">
                <div class="ws-col-label">
                  <span class="ws-label">{{ $t(`${i18nWsKey}.label_1_second_ago`) }}</span>
                </div>
                <div class="ws-col-media">
                  <canvas ref="second_image" class="img-fluid" :width="width" :height="height"></canvas>
                </div>
              </div>
              <div class="ws-line">
                <div class="ws-col-label">
                  <span class="ws-label">{{ $t(`${i18nWsKey}.label_2_seconds_ago`) }}</span>
                </div>
                <div class="ws-col-media">
                  <canvas ref="third_image" class="img-fluid" :width="width" :height="height"></canvas>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="row g-3 mb-2">
              <div class="col-12 col-md-6">
                <figure class="d-flex flex-column align-items-center text-center m-0">
                  <canvas ref="first_image" class="img-fluid" :width="width" :height="height"></canvas>
                  <figcaption class="mt-2 font-weight-bold">
                    {{ $t(`${i18nWsKey}.label_left_image`) }}
                  </figcaption>
                </figure>
              </div>
              <div class="col-12 col-md-6">
                <figure class="d-flex flex-column align-items-center text-center m-0">
                  <canvas ref="second_image" class="img-fluid" :width="width" :height="height"></canvas>
                  <figcaption class="mt-2 font-weight-bold">
                    {{ $t(`${i18nWsKey}.label_right_image`) }}
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
          <div>
            <table class="table table-sm overflow-auto simple-table mt-3" style="font-size: 85%;">
              <tr>
                <td>{{ $t(`${i18nWsKey}.label_history_name`) }}</td>
                <td>{{ selectedPreviewItem.displayName }}</td>
              </tr>
              <tr>
                <td>{{ $t(`individual.header_vehicle_dtc_table_date_time_occurrence`) }}</td>
                <td>{{ selectedDateItem.date_time }}</td>
              </tr>
              <tr>
                <td>{{ $t(`individual.label_table_header_ig_on_count`) }}</td>
                <td>{{ selectedDateItem.ig_on_time }}</td>
              </tr>
            </table>
          </div>
        </template>
      </div>
    </b-overlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center">
      <b-button v-if="phase === 'start'" size="sm" variant="primary" @click="onOkClicked" class="mx-2"
        :disabled="isDisableOk">
        {{ $t('message.button_agreement_confirm') }}
      </b-button>
      <b-button v-if="phase === 'select'" size="sm" variant="primary" @click="onOkClicked" class="mx-2"
        :disabled="isDisableOk">
        {{ $t('message.common_button_select') }}
      </b-button>
      <b-button v-if="phase === 'history_list'" size="sm" variant="primary" @click="onOkClicked" class="mx-2"
        :disabled="isDisableOk">
        {{ $t('message.common_button_save') }}
      </b-button>
      <b-button v-if="showButtonOk" size="sm" variant="primary" @click="onOkClicked" class="mx-2"
        :disabled="isDisableOk">
        {{ $t('message.common_button_ok') }}
      </b-button>
      <b-button v-if="showButtonCancel" size="sm" variant="outline-primary" @click="onCancelClicked" class="mx-2"
        :disabled="isLoading">
        {{ $t('message.common_button_back') }}
      </b-button>
      <b-button v-if="phase === 'preview_display'" size="sm" variant="outline-primary" @click="onOkClicked" class="mx-2"
        :disabled="isDisableOk">
        {{ $t('individual.label_button_finish') }}
      </b-button>
    </div>
  </template>
</b-modal>